import config from '@/api/config'

// Plan Public IDs
export const PLAN_PUBLIC_IDS = {
  // Common Plans
  free: "free",
  freeTrial: "free_trial",

  // New Plans
  paddle_bronze_monthly: "paddle_bronze_monthly",
  paddle_bronze_yearly: "paddle_bronze_yearly",
  paddle_silver_monthly: "paddle_silver_monthly",
  paddle_silver_yearly: "paddle_silver_yearly",
  paddle_gold_monthly: "paddle_gold_monthly",
  paddle_gold_yearly: "paddle_gold_yearly",

  // Legacy
  paddle_starter: "paddle_starter",
  paddle_single_annual: "paddle_single_annual",
  paddle_pro: "paddle_pro",
  paddle_pro_annual: "paddle_pro_annual",
  paddle_scale: "paddle_scale",
  paddle_scale_annual: "paddle_scale_annual",
  paddle_enterprise: "paddle_enterprise",
  paddle_enterprise_annual: "paddle_enterprise_annual",
};

export const planPublicIds = PLAN_PUBLIC_IDS

export const BILLING_PRICE_ID_MAP = {
  // Standard Paddle Billing catalog prices only. Migrated legacy prices stay server-side on subscriptions.
  [PLAN_PUBLIC_IDS.paddle_bronze_monthly]: config.paddle.billing?.prices?.bronzeMonthly,
  [PLAN_PUBLIC_IDS.paddle_bronze_yearly]: config.paddle.billing?.prices?.bronzeYearly,
  [PLAN_PUBLIC_IDS.paddle_silver_monthly]: config.paddle.billing?.prices?.silverMonthly,
  [PLAN_PUBLIC_IDS.paddle_silver_yearly]: config.paddle.billing?.prices?.silverYearly,
  [PLAN_PUBLIC_IDS.paddle_gold_monthly]: config.paddle.billing?.prices?.goldMonthly,
  [PLAN_PUBLIC_IDS.paddle_gold_yearly]: config.paddle.billing?.prices?.goldYearly,
};
